import * as React from "react"
import { t } from "@/i18n"
import injectSheet from "react-jss"
import compose from "recompose/compose"
import { withi18n } from "@/helpers/hoc/withi18n"
import { color } from "@xingternal/360-styles/helpers"
import { Icon, Loading, Text } from "@xingternal/360-components"
import { getProduct } from "@/helpers/products"
import { onlyfyFullTheme } from "@xingternal/rebranding-adapter"

const i18n = {
  fencedLink: "360_RECRUITER_INSIGHTS_FECING_LINK02",
  findOutMore: "360_RECRUITER_INSIGHTS_FIND_OUT_MORE",
}

const styles = {
  wrapper: {
    composes: "border-bottom border-gray-30",
    borderBottom: ({ highlight }) => highlight && "none",
    borderRadius: "4px 4px 0 0",
  },
  header: {
    composes: "pl24 pr24 pb16 pt16 flex justify-between align-items-center",
    background: ({ highlight }) => highlight && onlyfyFullTheme.colors.blue10,
    color: ({ highlight }) => highlight && color("white"),
  },
  append: { composes: "ml8" },
  fencedLinkContainer: { composes: "flex align-items-baseline" },
  fencedIcon: { composes: "mr8" },
  fencedLink: {
    composes:
      "cursor-pointer p0 m0 border-none petrol-link outline-none text-align-left",
    background: "none",
  },
  seatAvailableMessage: {
    composes: "px12 py8 mb16 mx16 rounded bg-gray-5",
  },
  seatAvailableMessageText: {
    composes: "tp13",
  },
  findOutMore: { composes: "pt8" },
}

const enhance = compose(withi18n(i18n), injectSheet(styles))

const FencedLink = enhance(({ classes, onClick, fencedLink }) => (
  <div className={classes.fencedLinkContainer}>
    <Icon
      className={classes.fencedIcon}
      name="core-graph-high"
      color={color("gray-50")}
    />
    <button className={classes.fencedLink} onClick={onClick}>
      <Text bold>{fencedLink}</Text>
    </button>
  </div>
))

const FencedBox = enhance(({ classes, onClick, product }) => (
  <div className={classes.seatAvailableMessage}>
    <div className={classes.seatAvailableMessageText}>
      {t("360_RECRUITER_INSIGHTS_ACCESS", { name: getProduct(product).title })}
    </div>
    <div className={classes.findOutMore}>
      <button className={classes.fencedLink} onClick={onClick}>
        <Text bold>{t(i18n.findOutMore)}</Text>
      </button>
    </div>
  </div>
))

const KpiPanelHeader = ({
  children,
  classes,
  isFailed,
  isUpdating,
  fenced,
  openLightbox,
  product,
  showAvailableProductNotice,
}) => (
  <div className={classes.wrapper}>
    <div className={classes.header}>
      <Text size={18} bold>
        {children}
        {isUpdating && <Loading content small className={classes.append} />}
        {isFailed && !isUpdating && (
          <Icon
            name="core-warning"
            color={color("red")}
            className={classes.append}
          />
        )}
      </Text>
      {fenced && <FencedLink onClick={openLightbox} />}
    </div>
    {showAvailableProductNotice && (
      <FencedBox onClick={openLightbox} product={product} />
    )}
  </div>
)

export const EnhancedKpiPanelHeader = enhance(KpiPanelHeader)
export default KpiPanelHeader
